export const SOCIAL_LINKS = {
  GITHUB: "https://github.com/JohnLinth",
  LINKEDIN: "https://www.linkedin.com/in/john-linthicum",
  UNIVERSITY: "https://h-da.de/en/studies/study-programmes/study-programmes/information-science-and-informatics/computer-science-bachelors-degree"
};

export const SUPPORTED_LANGUAGES = ['en', 'de']; 